import { mapMultiSelectDropDownField } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../../contexts/app';
import { QuotePlanSchema } from '../../../server/map-quotes';
import { QuoteFilters } from '../useQuoteFilterSchema';

export type IdLabel = {
	id: number;
	label: string;
};

export const useConsultationCoPay = (originalQuotes: QuotePlanSchema[]) => {
	const { translate } = useAppPlatformContextOptions();

	const qualifiedConsultationCopay = [...new Set(originalQuotes?.map((q) => q.coPaymentsOPConsultations))]?.map(
		(q, idx) => {
			return {
				id: idx,
				label: q,
			};
		}
	);

	const getConsultationCopay = mapMultiSelectDropDownField<QuoteFilters, IdLabel, 'label'>({
		field: 'opConsultationCoPaymentId',
		isEditable: true,
		options: qualifiedConsultationCopay,
		label: translate('quote-list:filters.consultation-copayment'),
		placeholder: translate('quote-list:select'),
		isHidden: false,
		valueKey: 'label',
		labelKey: 'label',
		cancelButtonText: translate('quote-list:filters.cancel'),
		applyButtonText: translate('quote-list:filters.apply'),
	});

	return { getConsultationCopay };
};
